import { blackOrange, blue, textMuted, white } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import { breakpoints, radii } from '@/theme/tokens'
import styled from 'styled-components'

export const HeroWrap = styled.header`
	position: relative;
`

export const HeroTopBar = styled.div`
	display: flex;
	justify-content: flex-end;
	min-height: 8px;
`

export const HeroCenter = styled.div`
	text-align: center;
	padding: 12px 0 44px;

	@media (max-width: ${breakpoints.bentoCollapse}px) {
		padding: 8px 0 32px;
	}
`

export const HeroTitle = styled.h1`
	font-family: ${fontDisplay};
	font-weight: 900;
	font-size: clamp(38px, 5vw, 54px);
	letter-spacing: -0.01em;
	line-height: 1.05;
	color: ${blackOrange};
	margin: 0 0 14px;
	text-wrap: balance;

	@media (max-width: ${breakpoints.phone}px) {
		font-size: 32px;
	}
`

export const HeroMeta = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	flex-wrap: wrap;
`

export const DaysPill = styled.span`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 14px;
	background: ${blue};
	color: ${white};
	border-radius: ${radii.pill};
	padding: 7px 16px;
`

export const HeroDates = styled.span`
	font-family: ${fontBody};
	font-size: 16px;
	color: ${textMuted};
`

export const HeroAvatars = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 14px;
`
